export default __webpack_public_path__ + "static/media/logo.4884b6f5.svg";